export const Notification_Content = [
    {
        id: 1,
        Messege: "New Batch Started for Class 12th"
    },
    {
        id: 2,
        Messege: "New Batch Started for Class 12th"
    },
    {
        id: 3,
        Messege: "New Batch Started for Class 12th"
    },
    {
        id: 4,
        Messege: "New Batch Started for Class 12th"
    }
]